import { numbers } from './common/constants';
import { keyCodes } from './platform/default/mapping';

export const keyCodeToNumber = keyCode => numbers?.[keyCodes?.[keyCode]];
